<template>
    <div class="theme-input hrm_input">
        <div class="relative">
            <label v-if="fieldLabel" class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
                {{ fieldLabel }}
                <span v-if="fieldRequired" class="text-base font-bold text-red-600">*</span>
            </label>
            <input :type="fieldType" class="hrm_input_field hrmInput mt-2 block text-sm px-2.5 pb-2 pt-2 w-full shadow-transparent 
                text-base text-gray-400 dark:text-gray-100 bg-gray-200 dark:bg-slate-700 bg-gray-300 
                rounded-sm border border-gray-400 focus:border-amber-500 outline-0 focus:outline-0"
                :placeholder="fieldPlaceholder" v-model="fieldValue" @input="onInput" @keydown="onKeyDown"/>
            <span v-if="fieldError" class="mt-2 text-xs text-red-600 theme-error-message">
                {{ fieldError }}
            </span>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    fieldLabel: {
        type: String,
        default: null
    },
    fieldRequired: {
        type: Boolean,
        default: false
    },
    fieldType: {
        type: String,
        default: 'text'
    },
    fieldPlaceholder: {
        type: String,
        default: 'Enter your text'
    },
    fieldError: {
        type: String,
        default: null
    },
    onKeyDown: {
        type: Function,
        default: null
    }
})

const fieldValue = ref<string | number>("");

const emit = defineEmits(['update:modelValue'])

const onInput = (event: Event) => {
    emit('update:modelValue', (event.target as HTMLInputElement).value)
}

onMounted(() => {
    fieldValue.value = props.modelValue;
})
</script>